import { Layer, Spinner } from 'grommet';

export const Loader = ({ target }: { target?: HTMLDivElement }) => {
  return (
    <Layer background="light-1" target={target || undefined}>
      <Spinner size="large" background="light-1" />
    </Layer>
  );
};
